import { render, staticRenderFns } from "./chooseGame.vue?vue&type=template&id=41d912bd&scoped=true&"
import script from "./chooseGame.vue?vue&type=script&lang=js&"
export * from "./chooseGame.vue?vue&type=script&lang=js&"
import style0 from "./chooseGame.vue?vue&type=style&index=0&id=41d912bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d912bd",
  null
  
)

export default component.exports